export const termsOfUseUrl = {
  figOnly: 'https://www.figmarketing.com/files/FIG_TERMS_OF_USE_11_12_2021.pdf',
};

export const privacyPolicyUrl = 'https://www.figmarketing.com/files/FIG_PRIVACY_POLICY.pdf';